import React from 'react'

export const ComingSoon = () => {
  return (
    <div style={{margin:75}}>Coming Soon...</div>
  )
}
